import {
  Response,
  Contact,
  Reaction,
  Message,
  Appointment,
} from 'store/api/models';

export const responseInitialValues = (
  response: Response,
  message_type: 'TO' | 'CC' | 'BCC' | string,
  contact_r: Contact
) => {
  return {
    ...response.r_message_r,
    recipients: response?.contacts
      ?.filter(
        (contact: Contact) => !contact.author && contact.message_type === 'TO'
      )
      .map((contact: Contact) => ({
        ...contact,
        name:
          contact.firstname && contact.firstname !== ''
            ? `${contact.firstname} ${contact.lastname}`
            : contact.email,
      })),
    cc: response?.contacts
      ?.filter(
        (contact: Contact) => !contact.author && contact.message_type === 'CC'
      )
      .map((contact: Contact) => ({
        ...contact,
        name:
          contact.firstname && contact.firstname !== ''
            ? `${contact.firstname} ${contact.lastname}`
            : contact.email,
      })),
    bcc:
      message_type === 'BCC'
        ? [
            {
              ...(contact_r || {}),
              name:
                contact_r?.firstname && contact_r?.firstname !== ''
                  ? `${contact_r?.firstname} ${contact_r?.lastname}`
                  : contact_r?.email,
            },
          ]
        : undefined,
    from: [
      {
        ...response.contact_r,
        name: `${response.contact_r.firstname} ${response.contact_r.lastname}`,
      },
    ],
    form: {
      ...response.form,
      body: response.form?.body?.map((item: any, index: number) => {
        if (item.type) {
          const reaction = response.reactions?.find(
            (a: any) => a.form?.name === `form.body.${index}.action`
          );
          if (reaction) {
            return {
              ...item,
              action: {
                ...item.action,
                attachments: reaction?.action_r?.attachments,
                reactionattachments: reaction?.reactionattachments,
                status: reaction?.status,
              },
              form: {
                ...item.form,
                ...(reaction?.form || []),
              },
            };
          } else {
            return item;
          }
        } else if (item.preamble) {
          return {
            ...item,
            replyattachments: response.attachments,
          };
        } else {
          return item;
        }
      }) || [
        {
          text: `${
            response.r_message_r.details
              ? `${response.r_message_r.details}\n\n`
              : ''
          }${
            response?.reactions?.[0]?.action_r?.title
              ? `${response?.reactions?.[0]?.action_r?.title}:\n`
              : ''
          }${
            response?.reactions?.[0]?.action_r?.details
              ? response?.reactions?.[0]?.action_r?.details
              : ''
          }`,
        },
        ...(response?.reactions?.map((reaction: Reaction, index: number) => {
          let item = {
            action: {
              ...reaction?.action_r,
              status: reaction.status.replaceAll('-', ' '),
              reactiondetails: reaction.details,
              reactionattachments: reaction.reactionattachments,
            },
            text: '',
          };

          if (response.reactions.length - 1 >= index + 1) {
            item.text = `${
              reaction?.action_r?.details
                ? `${reaction?.action_r?.details}\n\n`
                : ''
            }${
              response?.reactions?.[index + 1]?.action_r?.title
                ? `${response?.reactions?.[index + 1]?.action_r?.title}:\n`
                : ''
            }${
              response?.reactions?.[index + 1]?.action_r?.details
                ? response?.reactions?.[index + 1]?.action_r?.details
                : ''
            }`;
          }
          return item;
        }) || []),
      ],
    },
  };
};

export const messageInitialValues = (
  message: Message,
  message_type: string,
  contact_r: Contact
) => {
  return {
    from: [
      {
        ...message?.contact_r,
        name: `${message.contact_r.firstname} ${message.contact_r.lastname}`,
      },
    ],
    recipients: message?.contacts
      ?.filter(
        (contact: Contact) => !contact.author && contact.message_type === 'TO'
      )
      .map((contact: Contact) => ({
        ...contact,
        name:
          contact.firstname && contact.firstname !== ''
            ? `${contact.firstname} ${contact.lastname}`
            : contact.email,
      })),
    cc: message?.contacts
      ?.filter(
        (contact: Contact) => !contact.author && contact.message_type === 'CC'
      )
      .map((contact: Contact) => ({
        ...contact,
        name:
          contact.firstname && contact.firstname !== ''
            ? `${contact.firstname} ${contact.lastname}`
            : contact.email,
      })),
    bcc:
      message_type === 'BCC'
        ? [
            {
              ...(contact_r || {}),
              name:
                contact_r?.firstname && contact_r?.firstname !== ''
                  ? `${contact_r?.firstname} ${contact_r?.lastname}`
                  : contact_r?.email,
            },
          ]
        : message?.contacts
            ?.filter(
              (contact: Contact) =>
                !contact.author && contact.message_type === 'BCC'
            )
            .map((contact: Contact) => ({
              ...contact,
              name:
                contact.firstname && contact.firstname !== ''
                  ? `${contact.firstname} ${contact.lastname}`
                  : contact.email,
            })),
    ...message,
    form: {
      ...message?.form,
      canceled: false,
      body: message?.form?.body?.map((item: any, index: number) => {
        if (item.type) {
          const action = message?.actions?.find(
            (a: any) => a.form?.name === `form.body.${index}.action`
          );
          if (action) {
            return {
              ...item,
              text:
                item.type === 'auto_salutation'
                  ? `Hey ${(contact_r?.firstname || '') + ',\n'}`
                  : item?.text,
              form: {
                ...(item?.form || {}),
                text:
                  item.type === 'auto_salutation'
                    ? `Hey ${(contact_r?.firstname || '') + ',\n'}`
                    : item?.form?.text,
              },
              action: {
                ...item.action,
                ...action,
                form: {
                  ...(action?.form || item?.action?.form || {}),
                  text:
                    item.type === 'auto_salutation'
                      ? `Hey ${(contact_r?.firstname || '') + ',\n'}`
                      : action?.form?.text || item?.action?.form?.text,
                },
                custom_inputs: item.action?.custom_inputs,
                status: undefined,
              },
            };
          } else {
            return item;
          }
        } else {
          return item;
        }
      }),
    },
    // contact: email?.contact,
  };
};

export const meetingInitialValues = (
  response: Response,
  contact_r: Contact,
  subject: string
) => {
  const daterange =
    response.form?.body?.find((b: any) => b.type === 'date_range')?.action
      ?.daterange?.reply[0] ||
    response.form?.body?.find((b: any) => b.type === 'date_range')?.action
      ?.daterange?.suggest[0];
  const contact = response.contact_r;
  return {
    from: [
      {
        ...contact_r,
        name: `${contact_r.firstname} ${contact_r.lastname}`,
      },
    ],
    recipients: [
      {
        ...contact,
        name:
          contact.firstname && contact.firstname !== ''
            ? `${contact.firstname} ${contact.lastname}`
            : contact.email,
      },
    ],
    subject: subject,
    form: {
      selected: response.id,
      address: response.form.address,
      city: response.form.city,
      state: response.form.state,
      zipcode: response.form.zipcode,
      copy_project: response.form.copy_project,
      auto_salutation: true,
      canceled: false,
      body: [
        {
          type: 'auto_salutation',
          text: 'Hey {{first_name}},\n',
          disabled: true,
        },
        {
          text: '',
          placeholder: 'Add email message\n',
        },
        {
          type: 'share_file',
          text: '',
        },
      ],
    },
    start_date: daterange?.start,
    due_date: daterange?.end,
    dates: daterange?.start || daterange?.end,
  };
};

export const appointmentInitialValues = (
  appointment: Appointment,
  contact_r?: Contact
) => {
  const author = appointment.contacts?.find(c => c.author);
  return {
    ...appointment,
    start_date: appointment?.start_time,
    due_date: appointment?.end_time,
    dates: appointment?.start_time || appointment?.end_time,
    recipients: appointment?.contacts
      ?.filter((contact: Contact) => !contact.author)
      .map((contact: Contact) => ({
        ...contact,
        name:
          contact.firstname && contact.firstname !== ''
            ? `${contact.firstname} ${contact.lastname}`
            : contact.email,
      })),
    from: [
      {
        ...(author || {}),
        name: `${author?.firstname} ${author?.lastname}`,
      },
    ],
    form: {
      ...appointment.form,
      body: appointment.form?.body?.map((item: any, index: number) => {
        if (item.action) {
          return {
            ...item,
            action: {
              ...(item.action || {}),
              attachments: appointment?.attachments,
            },
            form: {
              ...(item.form || {}),
              action: {
                ...(item.form?.action || {}),
                attachments: appointment?.attachments,
              },
            },
            // replyattachments: appointment?.attachments,
          };
        } else {
          return {
            ...item,
            text:
              item.type === 'auto_salutation' && contact_r
                ? `Hey ${(contact_r?.firstname || '') + ',\n'}`
                : item?.text,
          };
        }
      }) || [
        {
          text: `${appointment.details ? `${appointment.details}\n\n` : ''}${
            appointment?.actions?.[0]?.title
              ? `${appointment?.actions?.[0]?.title}:\n`
              : ''
          }${
            appointment?.actions?.[0]?.details
              ? appointment?.actions?.[0]?.details
              : ''
          }`,
        },
        // ...(appointment?.actions?.map(
        //   (action: Action, index: number) => {
        //     let item = {
        //       action: appointment?.actions?.[index],
        //       text: '',
        //     };

        //     if (appointment.actions.length - 1 >= index + 1) {
        //       item.text = `${
        //         appointment.details
        //           ? `${appointment.details}\n\n`
        //           : ''
        //       }${
        //         appointment?.actions?.[index + 1]?.title
        //           ? `${
        //               appointment?.actions?.[index + 1]?.title
        //             }:\n`
        //           : ''
        //       }${
        //         appointment?.actions?.[index + 1]?.details
        //           ? appointment?.actions?.[index + 1]?.details
        //           : ''
        //       }`;
        //     }
        //     return item;
        //   }
        // ) || []),
      ],
    },
  };
};
